import React, { useEffect, useState } from 'react';
import { InternalApiEntityGroup, InternalApiEntityType } from '../../../api-internal';
import { useQuerySegments } from './segmentActions';
import Has from '../../../auth/Has';
import { CAN_READ_ENTITY_GROUP } from '../../../auth/permissions';
import { SalvTable, SalvTextField, Size } from '@salvapp/ui-components';
import { faMagnifyingGlass } from '@fortawesome/pro-solid-svg-icons';
import './Segments.scss';
import { generatePath, useNavigate } from 'react-router';
import { InternalNavigation } from '../../../navigation/helper';
import useSegmentColumns from './useSegmentColumns';

interface Props {
  type: InternalApiEntityType;
}

const SegmentTable = ({ type }: Props) => {
  const navigate = useNavigate();
  const [filter, setFilter] = useState<string>();
  const [filteredGroups, setFilteredGroups] = useState<InternalApiEntityGroup[]>();
  const { data: segments, isPending } = useQuerySegments({ entityType: type });

  useEffect(() => {
    setFilteredGroups(
      (segments ?? []).filter((segment) => segment.name.toLowerCase().includes(filter?.toLowerCase() ?? ''))
    );
  }, [filter, segments]);

  const columns = useSegmentColumns();

  return (
    <div>
      <Has allPermissions={CAN_READ_ENTITY_GROUP}>
        <SalvTextField
          ariaLabel='Search Segment'
          className='m-b-16'
          placeholder='Search by name...'
          icon={faMagnifyingGlass}
          onChange={setFilter}
        />
        <SalvTable
          className='segment-table m-b-64'
          size={Size.SMALL}
          data={filteredGroups ?? []}
          columns={columns}
          isLoading={isPending}
          emptyMessage='No Segments found'
          rowClick={(row) => navigate(generatePath(InternalNavigation.segment, { code: row.original.code }))}
        />
      </Has>
    </div>
  );
};
export default SegmentTable;
